import Logo from '../logo';
import Dropdown from '@/components/utils/dropdown';
import MobileMenu from '../mobile-menu';
import RightNav from './right-nav';

export default function FullHeader() {
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-6">
      <div className="flex items-center justify-between h-16 md:h-20">
        {/* Site branding */}
        <div className="shrink-0 mr-5">
          <Logo />
        </div>

        {/* Desktop navigation */}
        <nav className="hidden md:flex md:grow">
          {/* Desktop menu links */}
          <ul className="flex grow justify-start lg:flex-wrap items-center">
            <li>
              <a
                href="https://penzu.com/pro"
                className="font-medium text-white hover:text-red-50 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out whitespace-nowrap"
              >
                Penzu Pro
              </a>
            </li>
            {/* Blog */}
            {/* <li>
              <a
                href="https://penzu.com/blog"
                className="font-medium text-white hover:text-red-50 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out whitespace-nowrap"
              >
                Blog
              </a>
            </li> */}
            <li>
              <a
                href="https://penzu.com/support"
                className="font-medium text-white hover:text-red-50 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out"
              >
                Support
              </a>
            </li>
            {/* 1st level: hover */}
            <Dropdown title="Download" caret={false}>
              {/* 2nd level: hover */}
              <li>
                <a
                  href={process.env.NEXT_PUBLIC_IOS_APP_URL || '#'}
                  className="font-medium text-sm text-gray-600 hover:text-blue-500 flex py-2 px-5 leading-tight"
                  target="_blank"
                >
                  iOS
                </a>
              </li>
              <li>
                <a
                  href={process.env.NEXT_PUBLIC_ANDROID_APP_URL || '#'}
                  className="font-medium text-sm text-gray-600 hover:text-blue-500 flex py-2 px-5 leading-tight"
                  target="_blank"
                >
                  Android
                </a>
              </li>
            </Dropdown>
          </ul>

          <RightNav />
        </nav>

        <MobileMenu />
      </div>
    </div>
  );
}
